export const Routes = {
	// INJECT_FROM_PLOP_TABLELIST
	DOCUMENT: '/documents',
	INVOICE: '/invoices',
	PROFILE: '/profile',
	REPORT: '/reports',
	HELP_CENTER: '/help-center',
	REGISTRATION_DOCUMENT: '/registration-document',
	SITE_VISIT: '/site-visits',
	DASHBOARD: '/'
}
